module.exports = __webpack_public_path__ + "static/media/company-profile-pic.f831e438.svg";